import { onlineApplicationsDefaultConfiguration } from "@/src/constants/applicationOnlineConsts";
import { admissionDatabaseDefaultConfiguration } from "@/src/constants/AdmissionOffice/admissionOfficeDatabaseConsts";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { sideBarMenuAllOptions } from "@/src/constants/sidebar";
import { getUserConfigFromStorage } from "@/src/utils/userConfigStorage";
import { IUserOptionsConfig } from "@/src/types/userOptions";

const userConfig = getUserConfigFromStorage();

const initialState: IUserOptionsConfig = {
  AOPConfig: {
    AOPTable: userConfig?.AOPConfig?.AOPTable || onlineApplicationsDefaultConfiguration,
    AOPFixed: userConfig?.AOPConfig?.AOPFixed ?? null,
  },
  AODPConfig: {
    AODPTable: userConfig?.AODPConfig?.AODPTable || admissionDatabaseDefaultConfiguration,
    AODPFixed: userConfig?.AODPConfig?.AODPFixed ?? null,
  },
  SideBarConfig: {
    list: userConfig?.SideBarConfig?.list || sideBarMenuAllOptions,
    // isOpen не устанавливается здесь - оно управляется только через localStorage в sideBarMenuSlice
  },
};

const userOptionsSlice = createSlice({
  name: "userOptions",
  initialState,
  reducers: {
    setActualUserConfig(state, action: PayloadAction<Partial<IUserOptionsConfig>>) {
      if (action.payload.AOPConfig) {
        state.AOPConfig = {
          ...state.AOPConfig,
          ...action.payload.AOPConfig,
        };
      }
      if (action.payload.AODPConfig) {
        state.AODPConfig = {
          ...state.AODPConfig,
          ...action.payload.AODPConfig,
        };
      }
      if (action.payload.SideBarConfig) {
        state.SideBarConfig = {
          list: action.payload.SideBarConfig.list || state.SideBarConfig.list,
          // isOpen не обновляем из конфигурации - оно управляется только через localStorage
        };
      }
    },
  },
});

export const { setActualUserConfig } = userOptionsSlice.actions;

export default userOptionsSlice.reducer;
